module.exports = __webpack_public_path__ + "img/apple0.3ce1ac29.png";